import React from "react";
import styled, { css } from "styled-components";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: max-content;
	height: max-content;
	position: relative;
`;

const Input = styled.input`
	margin: ${(props) => props.margin};
	border: ${(props) => props.border};
	padding: ${(props) => props.padding};
	font-size: ${(props) => props.fontSize};
	width: ${(props) => props.width};
	height: ${(props) => props.height};
	border-radius: 1rem;
	cursor: pointer;
	border-radius: 4px;
	box-shadow: ${(props) => props.boxShadow};
	@media (max-width: ${(props) => props.breakpoint}) {
		width: ${(props) => props.widthBeforeBreakpoint};
	}
	&:disabled {
		opacity: 0.5;
	}

	&:focus {
		${(props) =>
			props.errored &&
			css`
				outline: none;
			`}
	}

	${(props) =>
		props.errored &&
		css`
			border: 1px solid red;
		`}
`;

const Message = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	margin-top: 5px;
	text-align: center;
	color: red;
	font-size: 12px;
`;

Input.defaultProps = {
	padding: "0.5rem",
	fontSize: "1rem",
	width: "13em", 
	boxShadow: "none",
	border: "1px solid rgba(0,0,0,1)",
};

//TODO: Type Input box.

const InputBox = (props) => {
	return (
		<Wrapper>
			<Input {...props} />
			{props.errorMessage ? <Message>{props.errorMessage}</Message> : ""}
		</Wrapper>
	);
};

export default InputBox;
